// Where the property strategy tool opens (docs/property-strategy-spec.md).
// Plain data and 1 rule that read no build setting, so a test can import them (tests/e2e/property-strategy.spec.js).
// Stages 1 to 3 kept it off production (Netlify's CONTEXT), where the path fell through to the login door. Stage 4
// (Adam, 29 Oct 2026, "Tool and emails together") opens it everywhere, the same evening as live's HUB_STRATEGY_OPEN
// and MailerLite's follow-up emails. strategyOpen stays, so its 3 callers are unchanged.
export const STRATEGY_PATH = '/property-strategy'
// The tab's own run (sessionStorage, strategy/app.js), here so logging out can clear it (lib/auth.js) without loading
// the tool
export const STRATEGY_RUN_KEY = 'property-strategy-hub-v1'
export const STRATEGY_TITLE = 'Your property strategy'

export function strategyOpen() {
  return true
}

// Stage 2 (S2.8): the saved report, the same fixed address for everyone (email 1's link), with no id in it. Logged out
// it falls to the Library's login door; logged in it shows the person's latest saved report.
export const REPORT_PATH = '/property-strategy/report'
export const REPORT_TITLE = 'Your property strategy report'

export function isStrategyReport(path) {
  return String(path || '').split(/[?#]/)[0].replace(/\/+$/, '') === REPORT_PATH
}
